import React, { Component } from "react";
import { Link } from "react-router-dom";
import Api from "../Api";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import numeral from "numeral";
import ImageUri from '../ImageUri';
import moment from 'moment';
import ReactPaginate from "react-paginate";
UIkit.use(Icons);

export default class VisitNoteAbortion extends Component {
  state = {
    list: [], 
    keywordName: '',
    page: 1,
    pageAmount: 1,
    perPage: 10
  };

  componentDidMount() {
    this.visitNoteGet();
  } 

  visitNoteGet = async () => {
    var _response = await Api.consult("VisitNoteAbortion", {
      page: this.state.page,
      keywordName: this.state.keywordName
    });

    console.log(_response)


    this.setState({
      list: _response.data || [],
      pageAmount: Math.ceil(parseInt(_response.amount)) / this.state.perPage
    });
  };

  handlePageClick = (page) => {
    this.setState({ page: page.selected + 1 }, this.visitNoteGet)
  }

  paginateRender = () => {
    return <div className="uk-text-right">
            <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={this.state.pageAmount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          </div>
  }

  render() {
    return (
      <div className={this.props.paddingRemove === true ? '' : 'uk-padding'}>
        <div className={"uk-card uk-card-default uk-padding-small" + (
          this.props.paddingRemove === true ? '' : ' uk-margin-top'
        )}>
          <div className="d-card-header">
            <div className="d-card-header-left">บันทึกการดูแลด้านยุติการตั้งครรภ์</div>
            <div className="d-card-header-right"></div>
          </div>
          <div className="uk-grid uk-grid-small uk-flex-middle" >
            <div className="uk-width-expand@s  uk-margin-small-bottom">
              <input type="text" className="uk-input" placeholder="ค้นหาชื่อคนไข้" defaultValue={this.state.keywordName} onChange={(e)=>this.setState({keywordName: e.target.value, page: 1})} />
              </div> 
            <div className="uk-width-auto@s uk-width-1-1 uk-margin-small-bottom uk-text-right">
              <button className="uk-button uk-button-primary" onClick={this.visitNoteGet}>ค้นหา</button>
            </div> 
          </div>
          <div className="uk-overflow-auto">
            <table className="uk-table uk-table-divider">
              <thead>
              <tr>
                <th>ที่</th>
                <th style={{
                  minWidth: 100
                }}>สถานะ</th>
                <th style={{
                  minWidth: 120
                }}>วันที่บันทึก</th>
                <th>ชื่อไลน์</th>
                <th style={{
                  minWidth: 120
                }}>ชื่อ</th>
                <th style={{
                  minWidth: 120
                }}>นามสกุล</th>
                <th>เลขบัตรประชาชน</th>
                <th style={{
                  minWidth: 120
                }}>เบอร์ติดต่อ</th>
                <th>อายุ</th>
                <th>สถานภาพสมรส</th>
                <th>อายุครรภ์ (สัปดาห์)</th>
                <th style={{
                  minWidth: 120
                }}>LMP</th>
                <th>จำนวนการมีลูก</th>
                <th>จำนวนการทำแท้ง</th>
                <th style={{
                  minWidth: 120
                }}>เบอร์ติดต่อคนใกล้ชิด</th>
                <th>ความสัมพันธ์คนใกล้ชิด</th>
                <th>โรคประจำตัว</th>
                <th style={{
                  minWidth: 150
                }}>ท่านมีประวัติใดบ้าง</th>
                <th style={{
                  minWidth: 120
                }}>เคยแท้งหรือไม่ ด้วยวิธีใด</th>
                <th style={{
                  minWidth: 120
                }}>คุมกำเนิดด้วยวิธีใด</th>
                <th style={{
                  minWidth: 120
                }}>ต้องการถุงยางขนาดเท่าไหร่</th>
                <th style={{
                  minWidth: 120
                }}>กรุ๊ปเลือด</th>
                <th>ส่วนสูง (ซม.)</th>
                <th>นำหนัก (กก.)</th>
                <th>ที่อยู่สำหรับการจัดส่งยา</th>
                <th>รหัสไปรษณีย์</th>
                <th>lot no.</th>
                <th>DF</th>
                <th style={{
                  minWidth: 120
                }}>วันเดือนปีเกิด</th>
              </tr>
              </thead>
              <tbody>
                {this.state.list.length === 0 ? 
                <tr><td colSpan="100%" className="uk-padding-small uk-text-center">ไม่พบรายการ</td></tr> 
                  :

                this.state.list.map((data, index) => {
                  // console.log(data)
                  var _is_birthday_valid = moment(data.birthday, 'YYYY-MM-DD', true).isValid() || moment(data.birthday, 'YYYY-M-DD', true).isValid() || moment(data.birthday, 'YYYY-MM-D', true).isValid() || moment(data.birthday, 'YYYY-M-D', true).isValid();
 

                  var _age = '-';
                  if(_is_birthday_valid === true) {
                    _age =  moment().diff(data.birthday, 'years');

                  }

                  return <tr key={`rowCampaign${index}`}>
                    <td>{index+1}</td>
                    <td>{data.status}</td>
                    <td>{moment(data.dateadd).format('DD/MM/YYYY HH:mm')}</td>
                    <td>{`${data.linename}`}</td>
                    <td>{`${data.nameprefix} ${data.name}`}</td>
                    <td>{data.lastname}</td>
                    <td>{data.nid}</td>
                    <td>{data.tel}</td>
                    <td>{_age}</td>
                    <td>{data.wedding_status}</td>
                    <td>{data.gestational_age}</td>
                    <td>{data.lmp}</td>
                    <td>{data.number_of_children}</td>
                    <td>{data.number_of_abortion}</td>
                    <td>{data.relative_tel}</td>
                    <td>{data.close_relationship}</td>
                    <td>{data.congenital_disease}</td>
                    <td>{data.profile}</td>
                    <td>{data.have_abortion}</td>
                    <td>{data.birth_control}</td>
                    <td>{data.condom_size}</td>
                    <td>{data.blood_group}</td>
                    <td>{data.height}</td>
                    <td>{data.weight}</td>
                    <td>{data.address}</td>
                    <td>{data.postcode}</td>
                    <td>{data.lotno}</td>
                    <td>{data.df}</td>
                    <td>{data.birthday}</td>
                  </tr>
                })
              }
              </tbody>
            </table>
          </div>
          {this.paginateRender()}
        </div>
      </div>
    );
  }
}
